import { render, staticRenderFns } from "./sVip.vue?vue&type=template&id=56207370&"
import script from "./sVip.vue?vue&type=script&lang=js&"
export * from "./sVip.vue?vue&type=script&lang=js&"
import style0 from "./sVip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports